'use client'
import { useState } from 'react'
import { useTranslate } from '../../hooks'
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from '@repo/ui/components/tabs/tabs'
import { OrderbookOrders } from './orderbook.orders'
import { OrderbookTrades } from './orderbook.trades'
import { Card } from '@repo/ui/components'
import { cn } from '@repo/ui/lib'

interface OrderbookTabsProps {
  className?: string
  hideTabs?: boolean
  borderLess?: boolean
  paddingLess?: boolean
}

export function OrderbookTabs({
  className,
  hideTabs,
  borderLess,
  paddingLess,
}: OrderbookTabsProps) {
  const { t } = useTranslate()
  const [activeTab, setActiveTab] = useState('orders')

  return (
    <Card
      className={cn('space-md', className, {
        'border-none': borderLess,
        '!p-0': paddingLess,
      })}
    >
      <Tabs
        value={activeTab}
        onValueChange={setActiveTab}
        size='lg'
        color='base'
      >
        {!hideTabs && (
          <TabsList>
            <TabsTrigger value='orders' className='text-sm'>
              {t('orderbook_open_orders')}
            </TabsTrigger>
            <TabsTrigger value='trades' className='text-sm'>
              {t('orderbook_trade_history')}
            </TabsTrigger>
          </TabsList>
        )}
        <TabsContent value='orders' className='min-h-[335px]'>
          <OrderbookOrders hiddenAmount={hideTabs} />
        </TabsContent>
        <TabsContent value='trades' className='min-h-[335px]'>
          <OrderbookTrades />
        </TabsContent>
      </Tabs>
    </Card>
  )
}
